/* Costanti geometriche del layout — copiate 1:1 da flusso-urgenze.html (riga 661).
   Non toccare senza verificare la parità visiva. */
export const L = {
  colW: 218,
  marginL: 140,
  marginR: 88,
  headH: 96,
  row: 56,
  rowSync: 70,
  blockHead: 36,
  branchHead: 34,
  blockPad: 22,
  blockInset: 16,
  phaseH: 66,
  notePadX: 15,
  noteLine: 17,
  notePadY: 12,
  actW: 11,
  actStep: 5,
  boxW: 158,
  boxH: 36,
  gutterX: 104,
} as const;

/* Stringhe font per la misura del testo (canvas 2d). */
export const F_LAB = "13px 'Rethink Sans', system-ui, sans-serif";
export const F_COND = "12px 'Rethink Sans', system-ui, sans-serif";
export const F_NOTE = "12px 'Rethink Sans', system-ui, sans-serif";

/** Larghezza totale del diagramma dato il numero di partecipanti. */
export const totalWidth = (participantCount: number): number =>
  L.marginL + participantCount * L.colW + L.marginR;

/** x del centro della colonna i. */
export const colX = (i: number): number => L.marginL + i * L.colW + L.colW / 2;

/** Funzione di misura del testo iniettabile: canvas nel browser, stima altrove. */
export type Measure = (txt: string, font: string) => number;

/** Stima headless usata quando non c'è un canvas (test/server). */
export const estimateMeasure: Measure = (txt) => txt.length * 6.4;
